<script lang="ts">
    interface Props {
        icon: string;
    }

    let props = $props();
</script>

<svg class="bi {props.class}" style="{props.style || ""}" fill="currentColor" focusable="false">
    <!-- <use xlink:href="icons/bootstrap/{ICON_ID}.svg" style="color: red;"  -->
    <use xlink:href="icons/bootstrap-icons.svg#{props.icon}"/>/>
</svg>
